import { render, staticRenderFns } from "./DeveloperAccounting.vue?vue&type=template&id=496950e8&scoped=true"
import script from "./DeveloperAccounting.vue?vue&type=script&lang=js"
export * from "./DeveloperAccounting.vue?vue&type=script&lang=js"
import style0 from "./DeveloperAccounting.vue?vue&type=style&index=0&id=496950e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496950e8",
  null
  
)

export default component.exports